import type { TestContext } from "yup";
import { fileSize } from "util/validators";
import { PROOF_FILE } from "consts/ecommerce";
import type { ClientDocument } from "../types";

export function assertDocumentSize(this: TestContext, files: Array<ClientDocument> = []) {
    if (files.some((file: ClientDocument) => {
        if (typeof file.documentFileKey === 'string') {
            return false;
        }

        return !fileSize(PROOF_FILE.maxSize)(file.documentFileKey);
    })) {
        throw this.createError({
            message: 'File size is too large'
        });
    }

    return true;
};
